<template>
    <div class="modal fade" id="modal-alert" >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="p-3">{{ message }}</p>

                    <hr>
                    
                    <div class="d-flex flex-row-reverse">
                        <button class="btn btn-sm btn-light" @click="close">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'modal-alert',
        props: [ 'message' ],

        methods: {
            close() {
                this.$emit('close')
                $("#modal-alert").modal('hide')
            }
        }
    }
</script>